<template>
  <section id="partediario" class="section pt-5">
    <div class="container">
      <div class="columns is-mobile detail is-vcentered">
        <div class="column is-6 has-text-left code pl-0">
          <h3 class="has-text-weight-bold is-size-1 has-text-caxton-blue">
            {{ detruta.idruta }}{{ detruta.manyana_tarde == 0 ? "M" : "T" }}
          </h3>
        </div>
        <div class="column is-4 is-offset-1 has-text-left code pl-0">
          <div class="field"></div>
        </div>
        <div class="column is-1 has-text-right code pr-0">
          <button class="button ios" type="button" @click="$emit('close')">
            <b-image
              :src="require('@/assets/images/ico-close-yellow.png')"
              alt="Next"
            ></b-image>
          </button>
        </div>
      </div>
      <div class="tablas section pl-0 pr-0 pt-0">
        <div class="columns is-mobile detail encabezado">
          <div class="column is-full has-text-left name pt-0 pl-0">
            <h4 class="has-text-weight-bold has-text-caxton-blue is-size-4">
              Parte Diario
            </h4>
          </div>
        </div>
        <div class="columns is-mobile route annotations">
          <div class="column is-12">
            <div
              class="question mb-3 px-3 py-3 box"
              v-for="(question, index) in detruta.parte"
              :key="'parte-question-' + index"
            >
              <b-field
                :label="question.pregunta"
                v-if="question.tipo == 'radio'"
              >
                <b-radio
                  v-model="question.value"
                  :name="question.id"
                  native-value="0"
                >
                  No
                </b-radio>
                <b-radio
                  v-model="question.value"
                  :name="question.id"
                  native-value="1"
                >
                  Sí
                </b-radio>
              </b-field>

              <b-field
                :label="question.pregunta"
                v-if="question.tipo == 'hora'"
              >
                <b-timepicker
                  v-model="question.value"
                  rounded
                  placeholder="Introduce la hora"
                  icon="clock"
                  hour-format="24"
                  class="column is-3"
                  locale="es-ES"
                ></b-timepicker>
              </b-field>
            </div>
            <b-field label="Observaciones">
              <b-input
                placeholder="Observaciones"
                maxlength="200"
                type="textarea"
                v-model="detruta.observaciones"
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>
      <div class="columns is-mobile is-multiline route detail passengers">
        <div class="column is-full has-text-right">
          <b-button
            size="is-medium"
            type="is-caxton-blue"
            rounded
            icon-left="check"
            @click="$emit('close')"
            v-show="cumplimentado"
          >
          </b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["tr", "detruta"],
  name: "ParteDiario",
  methods: {},
  data() {
    return {};
  },
  computed: {
    cumplimentado() {
      return typeof this.detruta.parte.find(q => q.value == null) == "undefined"
        ? true
        : false;
    }
  }
};
</script>

<style scoped></style>
